import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from 'eddydata-lib';
import { ContratoLstComponent } from './contrato-lst/contrato-lst.component';
import { ContratoShwComponent } from './contrato-shw/contrato-shw.component';

const routes: Routes = [
  {
    path: 'pesquisa/:pagina/:data1/:data2',
    component: ContratoLstComponent, canActivate: [AuthGuard]
  },
  {
    path: 'pesquisa/:pagina/:data1/:data2/:filtro',
    component: ContratoLstComponent, canActivate: [AuthGuard]
  },
  {
    path: 'visualiza/:id/:pagina/:data1/:data2',
    component: ContratoShwComponent, canActivate: [AuthGuard]
  },
  {
    path: 'visualiza/:id/:pagina/:data1/:data2/:filtro',
    component: ContratoShwComponent, canActivate: [AuthGuard]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ContratoRoutingModule { }

